// extracted by mini-css-extract-plugin
export default {"sso_button_facebook":"FirebaseFacebookSignInButton_sso_button_facebook__3T4ks","sso_button_facebook_icon":"FirebaseFacebookSignInButton_sso_button_facebook_icon__sOSqm"};